import { inject, provide, ref, type Ref } from 'vue'

type ProjectTreeContext = {
  draggedOverFolderId: Ref<string | null>
  setDraggedOverFolderId: (id: string | null) => void
}

const projectTreeContextKey = Symbol('ProjectTreeContext')

/** Provides state values to all descendants of this component. */
export const useTreeContextProvider = (): ProjectTreeContext => {
  const draggedOverFolderId = ref<string | null>(null)
  const setDraggedOverFolderId = (id: string | null) => {
    draggedOverFolderId.value = id
  }

  provide(projectTreeContextKey, {
    draggedOverFolderId,
    setDraggedOverFolderId,
  })

  return {
    draggedOverFolderId,
    setDraggedOverFolderId,
  }
}

/** Used in descendants to access the state values and setters provided by the context provider. */
export const useProjectTreeDragContext = () => {
  const context = inject<ProjectTreeContext>(projectTreeContextKey)
  if (!context) {
    throw new Error('ProjectTreeContext not found')
  }
  return context
}
